module.exports = __webpack_public_path__ + "static/media/error_401.12142f4d.png";